import {
  ProductGroup,
  LegacyCollectionSearch,
  LegacyCollectionNav,
} from '@lambda/apis/src/product-group/types';

export const formatProductGroupAsLegacyCollectionSearch = (
  group?: ProductGroup,
): LegacyCollectionSearch => {
  if (group) {
    const filters: { brand?: string; categories?: string; psku?: string } = {};

    if (group.filters?.categories)
      filters.categories = group.filters.categories.join('|');

    if (group.filters?.brand) filters.brand = group.filters.brand.join('|');
    if (group.filters?.psku) filters.psku = group.filters.psku.join('|');

    return {
      query: group.filters?.query?.[0] ?? '',
      fullPhraseMatch: !!group.filters?.query,
      filters,
      sort: group.sortBy ?? 'price',
      order: group.sortOrder ?? 'asc',
    };
  }

  return {
    query: '',
    fullPhraseMatch: false,
    filters: {},
    sort: 'price',
    order: 'asc',
  };
};

export const formatProductGroupAsLegacyCollectionNav = (
  group: ProductGroup,
): LegacyCollectionNav => {
  const variantFilters: LegacyCollectionNav['fixedFilters']['variantFilters'] =
    {};
  const hideFilters: string[] = [];

  if (group.filters?.categories) {
    variantFilters.categories = group.filters.categories;
    hideFilters.push('categories');
  }

  if (group.filters?.brand) {
    variantFilters.brand = group.filters.brand;
    hideFilters.push('brand');
  }

  if (group.filters?.psku) variantFilters.psku = group.filters.psku;

  const nav: LegacyCollectionNav = { fixedFilters: { variantFilters } };

  if (hideFilters.length) nav.hideFilters = hideFilters;
  if (group.trackingPageType) nav.trackingPageType = group.trackingPageType;

  return nav;
};
